import React, { FC } from 'react';
import useTranslations from '@hooks/useTranslations';
import { FeatureDemandBannerProps } from '@components/FeatureDemandBanner/index';
import UIDuck from '../../redux/commonDucks/ui.duck';
import { ModalVersion } from '../../constants/main';
import { useDispatch } from 'react-redux';

const FeatureDemandBannerTemplate: FC<FeatureDemandBannerProps> = ({ className, image, label, title }) => {
    const { t } = useTranslations();

    const dispatch = useDispatch();

    return (
        <div className={className} style={{ backgroundImage: `url('${image}')` }}>
            <div>
                <span className="label">{label}</span>
                <h4 className="title">{title}</h4>
                <button
                    onClick={() =>
                        dispatch(
                            UIDuck.openModal({
                                data: {
                                    title,
                                },
                                modalType: UIDuck.MODAL_TYPES.FEATURE_DEMAND,
                                modalVersion: ModalVersion.v2,
                            })
                        )
                    }
                    className="link"
                >
                    {t('featureDemand.promo.link')}
                </button>
            </div>
        </div>
    );
};

export default FeatureDemandBannerTemplate;
